<template>
  <ul
    class="sc-object-card__list-cameras"
    v-if="fields && fields.length && !isLoading"
  >
    <li
      class="sc-object-card__list-cameras-item"
      v-for="(field, i) in fields"
      :key="field + i"
    >
      <list-item-camera :field="field" />
    </li>
  </ul>
  <div class="sc-object-card__list-cameras-no-data" v-else>
    <r-text>{{ $t("no-cameras") }}</r-text>
  </div>
</template>

<script>
import listItemCamera from "./renderer/list-item-camera";

export default {
  props: {
    fields: {
      type: Array,
      required: true,
      default: () => null
    }
  },
  components: { listItemCamera },
  data() {
    return {
      isLoading: false
    };
  },
  watch: {
    fields() {
      this.isLoading = true;

      setTimeout(() => {
        this.isLoading = false;
      }, 200);
    }
  }
};
</script>

<style lang="scss" scoped>
.sc-object-card__list-cameras {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  &-item {
    width: 48%;
    height: auto;
    margin-bottom: 16px;
    position: relative;
    border-radius: var(--border-radius);
    overflow: hidden;
    background-color: var(--bg_surface) !important;
  }
  &-no-data {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    max-height: 40px;
  }
}
</style>

<i18n>
{
  "ru": {
    "location": "Месторасположение",
    "no-cameras": "Камер нет",
    "status": "Статус"
  },
  "en": {
    "location": "Location",
    "no-cameras": "No cameras",
    "status": "Status"
  }
}
</i18n>
